import React from 'react'
import { useField } from 'formik'
import { TextArea } from '../../TextArea/TextArea'
import { FieldLabel } from '../FieldLabel/FieldLabel'
import { FieldError } from '../FieldError/FieldError'

export function FieldTextArea({ required, label, labelStyles = {}, ...props }) {
    const [field, meta] = useField(props)

    return (
        <div className="field-container">
            {label && <FieldLabel required={required} sx={labelStyles}>{label}</FieldLabel>}
            <TextArea {...props} {...field} />
            {!!meta.error && meta.touched && <FieldError>{meta.error}</FieldError>}
        </div>
    )
}

FieldTextArea.defaultProps = {
    required: false,
}
